<template>
    <div class="col-lg-12 mx-2">
        <ContentContainer>
            <template v-slot:content>
                <div class="w-50 mx-auto">
                    <p>Please fill out the form below detailing your request and we will get back to you as soon as
                        possible.</p>
                    <form @submit.prevent="handleSubmit">
                        <div class="mb-3">
                            <label for="topic" class="form-label fw-bold">Topic</label>
                            <select id="topic" v-model="selectedTopic" class="form-select" required>
                                <option value="" disabled>Select a topic...</option>
                                <option v-for="option in topicOptions" :key="option.value" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </select>
                        </div>
                        <MaterialTextarea id="request-assistance" name="requestAssistance" v-model="requestAssistance"
                            :isRequired="true" :disabled="false" :error="hasError" :success="isSuccessful"
                            variant="filled" placeholder="How may we help you"></MaterialTextarea>
                        <div class="my-2">
                            <material-button class="mb-2 py-2" size="sm" variant="gradient" color="success"
                                fullWidth>Submit</material-button>
                        </div>
                    </form>
                </div>
            </template>
        </ContentContainer>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import ContentContainer from '@/components/PageLayout/ContentContainer.vue';
import MaterialTextarea from '../components/common/MaterialTextarea.vue';
import MaterialButton from '../components/common/MaterialButton.vue';
import LoggerService from "@/services/LoggerService";

const store = useStore();
const toast = useToast();

// Reactive state
const requestAssistance = ref("");
const selectedTopic = ref("");
const hasError = ref(false);
const isSuccessful = ref(false);

const topicOptions = [
    { value: "question_functionality", label: "Question about functionality on this platform" },
    { value: "report_bug", label: "Report a bug/issue on this Platform" },
    { value: "question_activity", label: "Question about an Activity/Service" },
    { value: "feature_suggestion", label: "Feature suggestion for this platform" },
    { value: "other", label: "Other" },
];

// Computed
const stRequestAssistanceResponse = computed(() => store.getters.stRequestAssistanceResponse);
const stSessionData = computed(() => store.getters.stSessionData);

// Methods
const handleSubmit = async () => {
    try {
        const response = await store.dispatch('submitRequestAssistance', {
            message: requestAssistance.value,
            topic: selectedTopic.value,
        });
        
        // Log assistance request submission
        const requestId = response?.id || response?.requestid || response?.request_id || null;
        LoggerService.logDataOperation(
            'ASSISTANCE_REQUEST',
            'support',
            requestId,
            {
                topic: selectedTopic.value,
                requestContent: requestAssistance.value.substring(0, 100) + (requestAssistance.value.length > 100 ? '...' : ''),
                locationId: stSessionData.value?.locationid
            },
            stSessionData.value?.personId
        );
        
        toast.success(stRequestAssistanceResponse.value.message, {
            position: 'top-right',
        });
        requestAssistance.value = "";
        selectedTopic.value = "";
    } catch (err) {
        console.error('Error submitting request:', err);
    }
};
</script>
